export default function () {
    document.addEventListener('DOMContentLoaded', () => {
        const $teaserpillar = document.querySelectorAll('.ce__isnack-teaserpillar-teaser');

        if (!$teaserpillar.length) {
            return;
        }

        $teaserpillar.forEach((teaser) => {
            /*
             * BUGFIX:
             * need eqh for all element, nessessary for images.
             * all images have the same ratio x/y, but if an image is rendered e.g with heigth "420" and another with "421" (math round in browser),
             * the eqh element below has not the same top-offset and is handled as a new row - so the element has its own height-px and is not equal to its other dom elements.
             */
            const itemselectorImageBox = '#' + teaser.id + ' .ce__isnack-teaserpillar-teaser-image';
            const itemselectorOverline = '#' + teaser.id + ' h3';
            const itemselectorHeader = '#' + teaser.id + ' h2';
            const $equalHeightItemImageBox = teaser.querySelectorAll(itemselectorImageBox);
            const $equalHeightItemOverline = teaser.querySelectorAll(itemselectorOverline);
            const $equalHeightItemHeader = teaser.querySelectorAll(itemselectorHeader);

            if ($equalHeightItemImageBox.length > 0) {
                window.addEventListener('load', () => {
                    equalheight(itemselectorImageBox);
                });

                window.addEventListener('resize', () => {
                    setTimeout(() => {
                        equalheight(itemselectorImageBox);
                    });
                });

                // mobile devices rotation
                window.addEventListener('orientationchange', () => {
                    setTimeout(() => {
                        equalheight(itemselectorImageBox);
                    });
                });
            }

            if ($equalHeightItemOverline.length > 0) {
                window.addEventListener('load', () => {
                    equalheight(itemselectorOverline);
                });

                window.addEventListener('resize', () => {
                    setTimeout(() => {
                        equalheight(itemselectorOverline);
                    });
                });

                // mobile devices rotation
                window.addEventListener('orientationchange', () => {
                    setTimeout(() => {
                        equalheight(itemselectorOverline);
                    });
                });
            }

            if ($equalHeightItemHeader.length > 0) {
                window.addEventListener('load', () => {
                    equalheight(itemselectorHeader);
                });

                window.addEventListener('resize', () => {
                    setTimeout(() => {
                        equalheight(itemselectorHeader);
                    });
                });

                // mobile devices rotation
                window.addEventListener('orientationchange', () => {
                    setTimeout(() => {
                        equalheight(itemselectorHeader);
                    });
                });
            }
        });
    });
}
